import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './processes.intl.json';

export function useProcessesIntl() {
  return useIntlModule(messages);
}
